import { get, post, put } from "../client";
import axios from "axios";
import { BASE_URL } from "../../config";

function getHeaders() {
  return { Authorization: JSON.parse(localStorage.getItem("token") || "null") };
}

export default {
  get_payment_cred: async () => get("/business/get_PaymentCred"),

  add_payment_cred: async (data) => post("/business/add_PaymentCred", data),

  edit_payment_cred: async (data) => post("/business/edit_PaymentCred", data),

  make_payment_for_client: async (data) =>
    post("/business/make_payment_for_client", data),

  get_morning_account: async () => get("/business/invoices/morning-account"),


  // ── Hyp acquiring (self-serve connect / disconnect) ──
  get_hyp_status: async () => get("/hyp/onboarding"),

  hyp_onboarding_start: async (data) => post("/hyp/onboarding/start", data),

  hyp_disconnect: async (data) => put("/hyp/disconnect", data),

  get_invoices_list: async (params = {}) => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v != null)
    ).toString();
    const { data } = await axios.get(
      `${BASE_URL}/business/invoices/list?${query}`,
      { headers: getHeaders() }
    );
    return data;
  },

  create_invoice: async (data) => post("/business/invoices/create", data),

  get_business_purchases: async (params = {}) => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v != null)
    ).toString();
    const { data } = await axios.get(
      `${BASE_URL}/plan/business-purchases?${query}`,
      { headers: getHeaders() }
    );
    return data;
  },

  get_client_purchases: async (clientId) => {
    const { data } = await axios.get(
      `${BASE_URL}/plan/client-purchases/${clientId}`,
      { headers: getHeaders() }
    );
    return data;
  },

  get_plan_usage_history: async (planId) => {
    const { data } = await axios.get(
      `${BASE_URL}/plan/usage-history/${planId}`,
      { headers: getHeaders() }
    );
    return data;
  },

  pos_checkout: async (data) => {
    const { data: res } = await axios.post(
      `${BASE_URL}/pos/checkout`, data,
      { headers: getHeaders() }
    );
    return res;
  },

  get_all_memberships: async (params = {}) => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v != null)
    ).toString();
    const { data } = await axios.get(
      `${BASE_URL}/plan/all-memberships?${query}`,
      { headers: getHeaders() }
    );
    return data;
  },
};
